"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubtitleButton = exports.SubtitleAnchor = exports.SubtitleLink = exports.Subtitle = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const SUBTITLE_BASE_STYLE = 'text-xs font-bold uppercase tracking-widest';
const SUBTITLE_ACTION_STYLE = 'text-blue-5 hover:text-purple-6 hover:underline';
const Subtitle = ({ children, className }) => {
    return react_1.default.createElement("span", { className: (0, classnames_1.default)(SUBTITLE_BASE_STYLE, className) }, children);
};
exports.Subtitle = Subtitle;
const SubtitleLink = ({ to, tracking, children, className }) => {
    return (react_1.default.createElement(react_router_dom_1.Link, { to: to, className: (0, classnames_1.default)(SUBTITLE_BASE_STYLE, SUBTITLE_ACTION_STYLE, className, tracking) }, children));
};
exports.SubtitleLink = SubtitleLink;
const SubtitleAnchor = ({ href, target, tracking, children, className }) => {
    return (react_1.default.createElement("a", { href: href, target: target, rel: target === '_blank' ? 'noopener noreferrer' : undefined, className: (0, classnames_1.default)(SUBTITLE_BASE_STYLE, SUBTITLE_ACTION_STYLE, className, tracking) }, children));
};
exports.SubtitleAnchor = SubtitleAnchor;
const SubtitleButton = ({ onClick, disabled, tracking, children, className }) => {
    return (react_1.default.createElement("button", { onClick: onClick, disabled: disabled, role: "link", className: (0, classnames_1.default)(SUBTITLE_BASE_STYLE, SUBTITLE_ACTION_STYLE, 'disabled:opacity-60', className, tracking) }, children));
};
exports.SubtitleButton = SubtitleButton;
